import React, { Component } from "react";
import CancelAccountModal from "./CancelAccountModal/CancelAccountModal";
import Button from "../../Button/Button";
import "./EditAccount.css";

class EditAccount extends Component {
	componentWillMount() {
		// get editing section from url
		this.data = this.props.refreshedAccountInfo();
		this.section = this.props.match.params.section;

		this.sectionLabel = "";

		if (this.section === "edit-plan") {
			this.sectionLabel = "Edit Plan Information";
		} else if (this.section === "edit-basic-information") {
			this.sectionLabel = "Edit Basic Information";
		} else {
			window.location = "/404";
		}
	}
	render() {
		const basicInfoEditInputs = [
			"email",
			"password",
			"newPassword",
			"firstName",
			"lastName",
			"company"
		];

		const renderEditInputs = basicInfoEditInputs.map((i, index) => {
			return (
				<div className="edit-acct-section" key={index}>
					<label>
						{i.replace(/([A-Z])/g, " $1")}{" "}
						{i === "password" && <span>(Required)</span>}
					</label>
					<input
						defaultValue={
							this.data["basicInformation"][i]
								? this.data["basicInformation"][i]
								: ""
						}
						onChange={e =>
							this.props.onChangeInput(
								i,
								e.target.value,
								"updateAccountParams"
							)}
						type={i === "password" || i === "newPassword" ? "password" : "text"}
						required={i === "password" || i === "email" ? true : false}
					/>
				</div>
			);
		});

		const renderPlanChanges = (
			<div>
				<p className="account-current-plan">Current Plan</p>
				<p>{this.data["planSettings"]["currentPlan"].join(", ").replace(/_/g, ' ')}</p>
			</div>
		);
		return (
			<div className="edit-acct container">
				<div className="edit-acct-content">
					<h2>{this.sectionLabel}</h2>
					{this.section === "edit-basic-information" ? (
						<form>{renderEditInputs}</form>
					) : (
						renderPlanChanges
					)}
					{this.section === "edit-basic-information" ? (
						<Button
							label="Save Changes"
							onClick={() => this.props.postAccountChanges()}
						/>
					) : (
						<CancelAccountModal unsubcribePlan={this.props.unsubcribePlan} />
					)}
				</div>
			</div>
		);
	}
}

export default EditAccount;


// WEBPACK FOOTER //
// ./src/components/Account/EditAccount/EditAccount.js